import { useState } from 'react'

import {
  Download04Icon,
  Link02Icon,
  Image02Icon,
  PlayIcon
} from '@hugeicons/react'
import _ from 'lodash'

import { Button } from '@/shared/ui/Button'

type LibraryBottomSheetFooterProps = {
  archive_kind: string
  url?: string
  file?: { file: { url: string } }
  image?: { file: { url: string } }
  hasFinished: boolean
  locked: boolean
  onFinishResource: () => Promise<boolean | void>
}

const kindConfig: Record<
  string,
  {
    getHref: (props: LibraryBottomSheetFooterProps) => string
    label: string
    revisitLabel: string
    icon: typeof Link02Icon
  }
> = {
  link: {
    getHref: props => props.url || '',
    label: 'Acessar material',
    revisitLabel: 'Revisitar material',
    icon: Link02Icon
  },
  archive: {
    getHref: props => _.get(props.file, 'file.url', ''),
    label: 'Baixar arquivo',
    revisitLabel: 'Baixar novamente',
    icon: Download04Icon
  },
  image: {
    getHref: props => _.get(props.image, 'file.url', ''),
    label: 'Ver imagem',
    revisitLabel: 'Ver imagem novamente',
    icon: Image02Icon
  },
  video_url: {
    getHref: props => props.url || '',
    label: 'Assistir vídeo',
    revisitLabel: 'Assistir novamente',
    icon: PlayIcon
  },
  embedded: {
    getHref: props => props.url || '',
    label: 'Acessar conteúdo',
    revisitLabel: 'Revisitar conteúdo',
    icon: Link02Icon
  }
}

export const LibraryBottomSheetFooter = (
  props: LibraryBottomSheetFooterProps
) => {
  const { archive_kind, hasFinished, locked, onFinishResource } = props
  const [isSubmitting, setIsSubmitting] = useState(false)
  const kind = kindConfig[archive_kind]
  const href = kind?.getHref(props)

  if (!href || locked) {
    return (
      <div className="px-4 pb-2">
        <Button variant="secondary" size="lg" className="w-full" disabled>
          Indisponível
        </Button>
      </div>
    )
  }

  const Icon = kind.icon

  const handleOpen = async () => {
    if (isSubmitting) return

    setIsSubmitting(true)
    try {
      if (!hasFinished) {
        const ok = await onFinishResource()
        if (ok === false) return
      }

      window.open(href, '_blank', 'noopener,noreferrer')
    } finally {
      setIsSubmitting(false)
    }
  }

  const label = hasFinished ? kind.revisitLabel : kind.label

  return (
    <div className="px-4 pb-2">
      <Button
        type="button"
        variant={hasFinished ? 'success-ghost' : 'primary'}
        size="lg"
        className="w-full"
        leadingIcon={<Icon size={20} aria-hidden />}
        disabled={isSubmitting}
        onClick={() => {
          void handleOpen()
        }}
      >
        {isSubmitting ? 'Registrando acesso...' : label}
      </Button>
    </div>
  )
}
